(function() {
  angular.module('admin')
  .controller('gatUploadController',
    ['$http','$scope', '$log', '$state', 'FileUploader','$stateParams', '$cookies','$window','FileSaver',
    function($http,$scope, $log, $state, FileUploader,$stateParams, $cookies,$window,FileSaver) {
      var vm = this;
      vm.file = '';
      vm.replacegattable = false;
      vm.downloading = false;
      vm.running = false;
      vm.maxAllowedFileSize = 20000000;
      var headersObj =  {'x-auth-token' : $cookies.get('x-auth-token'), 'replacegattable' : vm.replacegattable};
      $scope.$watch('errorControl', function() {
        $scope.errorControl && $scope.errorControl.showErrors();
      });
     vm.uploader = new FileUploader({
        url: '/myDso/gatDocument',
        queueLimit: 1,
        removeAfterUpload: true,
        headers:  headersObj
      });
      vm.uploader.onProgressItem = function(evt) {
        vm.running = true;
      };
      vm.uploader.onBeforeUploadItem = function (item) {
              item.headers = headersObj
            };
      vm.uploader.onSuccessItem = function(item,response) {
        vm.running = false;
        vm.file='';
        if(response == true){
        	vm.showGatUploadSuccess = true;
        }else{
        	vm.showGatUploadWarning = true;
        }
      };
      vm.uploader.onErrorItem = function(item, response) {
        vm.running = false;
        vm.showGatUploadFail = true;
        //throw response;
      };
      vm.upload = function(item) {
        vm.showGatDownLoadSuccess = false;
        vm.showGatDownLoadFail = false;
        vm.downloading = false;
        $scope.errorControl.showErrors();
        if (isSupportedItem(item)){

            vm.uploader.uploadItem(item);
        }else{
          vm.uploader.cancelItem(item);
        }
      };
      vm.updateChkBoxValue = function(param) {
          vm.replacegattable = param;
          headersObj =  {'x-auth-token' : $cookies.get('x-auth-token'), 'replacegattable' : vm.replacegattable};
      };

      vm.reset = function(){
        vm.file='';
        $scope.gatUploadForm.locationsFile.$setValidity('fileType', true);
        $scope.gatUploadForm.locationsFile.$setValidity('fileSize', true);
        vm.showGatUploadSuccess = false;
        vm.showGatUploadWarning = false;
        vm.showGatUploadFail = false;
        vm.showGatDownLoadSuccess = false;
        vm.showGatDownLoadFail = false;
        vm.downloading = false

      };

      $scope.$watchCollection('vm.uploader.queue',(q)=>{
          vm.item = q ? q[0] : '';
      });


      function isSupportedItem(item) {
        var type = '|' + item.file.type.slice(item.file.type.lastIndexOf('/') + 1) + '|';
        var supportedType = '|vnd.ms-excel|vnd.openxmlformats-officedocument.spreadsheetml.sheet|'.indexOf(type) !== -1 ;
        var validFileSize = item.file.size <= vm.maxAllowedFileSize;

        $scope.gatUploadForm.locationsFile.$setValidity('fileType', supportedType);
        $scope.gatUploadForm.locationsFile.$setValidity('fileSize', validFileSize);
        return supportedType && validFileSize;
      }
      $scope.clearInputFilename = function () {
            angular.element("input[type='file']").val(null);
            vm.uploader.clearQueue();
            vm.showGatUploadSuccess = false;
            vm.showGatUploadWarning = false;
            vm.showGatUploadFail = false;
      };


      vm.download = function(){
            vm.showGatDownLoadSuccess = false;
            vm.showGatDownLoadFail = false;
            vm.showGatUploadSuccess = false;
            vm.showGatUploadWarning = false;
            vm.showGatUploadFail = false;
            vm.downloading = true;
            $scope.gatUploadForm.locationsFile.$setValidity('fileType', true);
            $scope.gatUploadForm.locationsFile.$setValidity('fileSize', true);
            $http({
                 url: '/myDso/downLoadGatData',
                 method: "GET",
                 responseType: "blob"

            }).then(function(responseType){
                  var file = new Blob([ responseType.data ], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });
                 // var objectUrl = URL.createObjectURL(file);
                 // $window.open(objectUrl);
                  var defaultFileName ="GatTableData.xlsx";
                   FileSaver.saveAs(file,defaultFileName);
                    vm.showGatDownLoadSuccess = true;
                    vm.downloading = false;
            },function(err) {
                   vm.showGatDownLoadFail = true
                   vm.downloading = false;
                   console.log('Error: ' + err);
             });

      }

    }]);
})();
